import { Table } from "antd";
import React, { useState } from "react";
import { useEffect } from "react";
import { withRouter } from "react-router-dom";

function TableSolSimilares(props) {
    const {data, loading} = props;
    const [dataSource, setDataSource] = useState([]); //hook para almacenar el array

    useEffect(() => {
        setDataSource(data);
    }, [data]);

    const columns = [
        {
            title: "#",
            dataIndex: "indice"
        },
        {
            title: "Nombre",
            dataIndex: "nombre"
        },
        {
            title: "Clave de elector",
            dataIndex: "claveElector"
        },
        {
            title: "Folio",
            dataIndex: "folio"
        },
        {
            title: "Junta de seguimiento",
            dataIndex: "junta"
        },
        {
            title: "Estado de la revisión",
            dataIndex: "estatusSol"
        }
    ];

    return (
        <>
            <Table columns={columns}
                locale={{ emptyText: "Sin registros" }}
                dataSource={dataSource}
                scroll={{ x: true }}
                loading={loading}
            />
        </>
    );
}

export default withRouter(TableSolSimilares);